import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PersistentDrawerLeft from './pages/PersistentDrawerLeft';
import { Logging } from './pages/Logging';
import { Dashboard } from './pages/Dashboard';
import { KOT } from './pages/KOT';
import { BOT } from './pages/BOT';
import { Room } from './pages/Room';
import { Customer } from './pages/Customer';
import Table from './pages/Table';
import ProtectedRoute from './component/ProtectedRoute';
import {OrdersDashboard} from "./component/OrdersDashboard";
import ReportDashboard from "./component/ReportDashboard";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                {/* Public login route */}
                <Route path="/" element={<Logging />} />

                {/* Shared layout for authenticated users */}
                <Route element={<PersistentDrawerLeft />}>
                    <Route path="/home" element={<Dashboard />} />

                    {/* Admin-only access using local role from localStorage */}
                    <Route
                        path="/report"
                        element={
                            <ProtectedRoute allowedRoles={['admin']}>
                                <ReportDashboard />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/order"
                        element={
                            <ProtectedRoute allowedRoles={['admin']}>
                                <OrdersDashboard />
                            </ProtectedRoute>
                        }
                    />

                    {/* Unrestricted sections (optional: add role checks if needed) */}
                    <Route path="/kot" element={<KOT />} />
                    <Route path="/bot" element={<BOT />} />
                    <Route path="/room" element={<Room />} />
                    <Route path="/customer" element={<Customer />} />
                    <Route path="/table" element={<Table />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );

}

export default App;
